export interface Alert {
  type: 'on-call' | 'info' | 'warning';
  message: string;
  timestamp: string;
  actions?: string[];
}
